export class AccountTypeConstants {
    public static Savings = "P";
    public static Checking = "B";

}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/account-type.constants.ts